import React from "react";
import * as Styled from "./styles";

const LoadingIcon = () => (
  <Styled.LoadingIcon>
    <svg viewBox="0 0 42 39" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Android"
        transform="translate(-159.000000, -301.000000)"
        stroke="#09A467"
        strokeWidth="2"
      >
        <Styled.LoadingPath />
      </g>
    </svg>
  </Styled.LoadingIcon>
);

export default LoadingIcon;
